<template>
  <section class="container loading-data">
    <div class="columns">
      <div class="column">
        <div class="box">
          <nav class="level is-mobile">
            <div class="level-left" />
            <div class="level-right">
              Total: {{ metadata.totalCount }}
            </div>
          </nav>
          <table class="table is-fullwidth">
            <thead>
              <tr>
                <th>Email</th>
                <th class="is-2">
                  Created At
                </th>
                <th class="is-2" />
              </tr>
            </thead>
            <tbody>
              <tr 
                v-for="(user) in users" 
                :key="user.id"
              >
                <td>
                  {{ user.email }}
                </td>

                <td>
                  {{ $formatFullDate(user.createdAt) }}
                </td>

                <td>
                  <div class="buttons">
                    <b-button 
                      size="is-small is-default" 
                      icon-left="eye" 
                      @click="showRecord(user.id)" 
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          
          <div class="columns is-mobile">
            <div class="column is-3" />

            <div class="column is-6">
              <b-pagination
                v-if="metadata.totalCount > metadata.limitValue"
                :total="metadata.totalCount"
                :current.sync="currentPage"
                :per-page="metadata.limitValue"
                range-before="3"
                range-after="3"
                order="is-centered"
                aria-next-label="Next page"
                aria-previous-label="Previous page"
                aria-page-label="Page"
                aria-current-label="Current page"
                class="pagination is-centered" 
              />
            </div>

            <div class="column is-3" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { paginationMixin, showMixin } from '@/mixins/crud/pagination'

  export default {
    name: 'UsersList',
    mixins: [ paginationMixin('user', 'email'), showMixin('user') ],
    computed: {
      ...mapGetters({
        users: 'users/all'
      }),
    },
    mounted() {
      this.load({page: 1})
    }
  }
</script>

<style lang="scss" scoped>
</style>
